import { lazy } from 'react';
export const KitchenPageAsync = lazy(() => import('./KitchenPage'));
